import script from "./ListTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListTable.vue?vue&type=script&setup=true&lang=ts"

import "./ListTable.vue?vue&type=style&index=0&id=1e18f2f1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e18f2f1"]])

export default __exports__